import { Typography } from '@mui/material'
import React, { Fragment } from 'react'

interface ListElementTextProps {
  title: string // values' label
  text: string | number | JSX.Element // value
  center?: boolean
}

export const ListElementText: React.FC<ListElementTextProps> = ({
  title,
  text,
  center = false
}) => {
  return (
    <Fragment>
      <Typography
        variant='body2'
        component='p'
        sx={{
          fontWeight: 'bold',
          p: 0,
          m: 0,
          textAlign: center ? 'center' : undefined
        }}
      >
        {title}
      </Typography>
      <Typography
        variant='body2'
        component='p'
        sx={{
          p: 0,
          m: 0,
          textAlign: center ? 'center' : undefined
        }}
      >
        {text}
      </Typography>
    </Fragment>
  )
}
